import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IContract, IContractFull, IContractInfo, IContractResponse } from "./IContract";

export const contractApi = createApi({
  reducerPath: "contract",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.CONTRACTS,
  }),
  tagTypes: ["contracts", "contract"],
  endpoints: (builder) => ({
    getFilteredContracts: builder.query<IContractResponse, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`,
        };
      },
      providesTags: ["contracts"],
    }),
    getAllContracts: builder.query<IContractFull[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contracts"],
    }),
    addContract: builder.mutation<IContract, Omit<IContract, "id">>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["contracts"],
    }),
    getContract: builder.query<IContractInfo, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contract"],
      transformResponse: (response: IContractFull) => {
        const { works, aircrafts, contractor, ...rest } = response;
        const contractor_id = contractor.id;
        const contractor_name = contractor.name;
        return { ...rest, contractor_id, contractor_name };
      },
    }),
    editContract: builder.mutation<IContract, IContract>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["contract", "contracts"],
    }),
    deleteContract: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["contracts"],
    }),
  }),
});

export const {
  useAddContractMutation,
  useDeleteContractMutation,
  useEditContractMutation,
  useGetAllContractsQuery,
  useGetContractQuery,
  useGetFilteredContractsQuery,
} = contractApi;
